import React from "react";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="container footer-inner">
        <p>© {year} Wellness Minds. All rights reserved.</p>
        <p className="footer-sub">
          Contact: <a href="mailto:support@wellnessminds.in">support@wellnessminds.in</a> ·
          Wellness Minds provides supportive information only and is not a replacement for
          professional mental health care or emergency services.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
